module.exports = __webpack_public_path__ + "static/media/karl_straub.558511eb.jpg";